export default [
  {
    key: 'disableAllNotification',
    label: 'field.disableAllNotification',
    type: 'checkbox',
    rules: 'required',
    cols: 12,
  },
  {
    key: 'onlineNotification',
    label: 'field.onlineNotification',
    type: 'checkbox',
    rules: 'required',
    cols: 12,
  },
  {
    key: 'offlineNotification',
    label: 'field.offlineNotification',
    type: 'checkbox',
    rules: 'required',
    cols: 12,
  },
  {
    key: 'emailNotification',
    label: 'field.emailNotification',
    type: 'checkbox',
    rules: 'required',
    cols: 12,
  },
  {
    key: 'soundNotification',
    label: 'field.soundNotification',
    type: 'checkbox',
    rules: 'required',
    cols: 12,
  },
]
